import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const customerAbuseDashboardConfigs = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/customer/abuse-dashboard',
        component: React.lazy(() => import('./CustomerAbuseDashboard/customerAbuseDashboard')),
        title: 'sidebar.customer_abuse_dashboard',
      },
    ],
  },
];
